// Styles
import "../../styles/OurWorks.css";
// Third-Party =====> bootstrap
import Card from "react-bootstrap/Card";
import { Button } from "react-bootstrap";
import Container from "react-bootstrap/Container";
// Third-Party =====> swiper
import { Swiper, SwiperSlide } from "swiper/react";
import { EffectCoverflow, Pagination, Navigation } from "swiper";
// API
import { useGetBusinessCardsQuery } from "../../redux/features/home/homeApiSlice";
// Data
import { BASE_URL } from "../../redux/api/apiSlice";
// Images
import cardicon1 from "../../assets/card-icon1.png";

import { Link } from "react-router-dom";

const Works = () => {
   // ################### RTK QUERY ###################
   const {
      data: businessCards,
      isSuccess,
      isLoading,
   } = useGetBusinessCardsQuery();

   // ################### CONTENT ###################
   let content;
   if (isSuccess && businessCards?.data?.length > 0) {
      content = (
         <Swiper
            spaceBetween={25}
            effect={"coverflow"}
            grabCursor={true}
            centeredSlides={true}
            slidesPerView={"auto"}
            initialSlide={1}
            coverflowEffect={{
               rotate: 0,
               stretch: 0,
               depth: 200,
               modifier: 1,
               slideShadows: true,
            }}
            navigation={{
               clickable: true,
            }}
            pagination={{
               clickable: true,
            }}
            modules={[EffectCoverflow, Pagination, Navigation]}
            className="mySwiper"
         >
            {businessCards?.data?.map((businessCard) => (
               <SwiperSlide key={businessCard?.id} style={{ height: "520px" }}>
                  <Link to={businessCard?.business_card_link}>
                     <Card
                        style={{ paddingBottom: "40px", height: "100%" }}
                        className="crd"
                     >
                        <Card.Img
                           variant="top"
                           src={`${BASE_URL}/${businessCard?.image}`}
                        />
                        <Card.Body>
                           <Card.Title style={{ fontSize: "24px" }}>
                              {businessCard?.title}
                           </Card.Title>
                           <Card.Text
                              style={{ color: "#A5A5A5", fontSize: "14px" }}
                              className="text"
                           >
                              {businessCard?.description}
                           </Card.Text>
                           {/* <Button className="card-btn">
                              <img src={cardicon1} alt="card-icon" />
                              تطبيق التعرفة الجمركية
                           </Button> */}
                        </Card.Body>
                     </Card>
                  </Link>
               </SwiperSlide>
            ))}
         </Swiper>
      );
   } else if (!isLoading) {
      content = <p className="soon">سيتم إضافة البيانات قريبا.</p>;
   }

   return (
      <section className="works" id="works">
         <Container>
            <h6 className="section-title">أعمالنا</h6>
            <p className="section-sub-title ">
               نقدم أفضل الخدمات في إدارة المشاريع و غيرها
            </p>
            {content}
         </Container>
      </section>
   );
};

export default Works;
